// extracted by mini-css-extract-plugin
export default {"widget":"favourites_widget__aajmq","list":"favourites_list__Xr-HN","item":"favourites_item__FtKH0"};